import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-meter-template',
  templateUrl: './meter-template.component.html',
  styleUrls: ['./meter-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeterTemplateComponent {
  @Input() set meterValue(value: number) {
    this.createMeterValues(value);
  }

  @Input() unit: string = '';

  rightValue!: string[];
  leftValue!: string[];

  private createMeterValues(value: number): void {
    const meterNumberCount = 8;
    const [leftSide, rightSide] = (Math.round(value * 1000) / 1000).toString().split('.');
    this.leftValue = leftSide.padStart(meterNumberCount, '0').split('');
    this.rightValue = (rightSide ?? '').padEnd(3, '0').split('');
  }
}
